export default "__VITE_PUBLIC_ASSET__b16a9f09__"